var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.382,
    height: 36,
    viewBox: "0 0 83.382 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1043.249 -537)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27 19)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(1016.249 547)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Oswald-Regular, Oswald"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STREAM")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1089.029 532.945)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.092 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.549)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.005)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.238,
    cy: 2.688,
    rx: 2.238,
    ry: 2.688,
    transform: "translate(0.163 0.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,371.962a2.436,2.436,0,1,1,2.4,2.85A2.656,2.656,0,0,1,137.9,371.962Zm.33,0a2.11,2.11,0,1,0,2.071-2.52A2.335,2.335,0,0,0,138.225,371.962Z",
    transform: "translate(-137.895 -369.112)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.996,
    cy: 1.194,
    rx: 0.996,
    ry: 1.194,
    transform: "translate(0.371 1.867)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.381)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.238,
    cy: 2.688,
    rx: 2.238,
    ry: 2.688,
    transform: "translate(0.161 0.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.257,371.962a2.435,2.435,0,1,1,2.4,2.85A2.659,2.659,0,0,1,140.257,371.962Zm.33,0a2.11,2.11,0,1,0,2.069-2.52A2.333,2.333,0,0,0,140.587,371.962Z",
    transform: "translate(-140.257 -369.112)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.996,
    cy: 1.194,
    rx: 0.996,
    ry: 1.194,
    transform: "translate(5.717 1.867)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.422,371.654a2.237,2.237,0,1,0-4.45,0Z",
    transform: "translate(-137.792 -369.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,371.741a2.4,2.4,0,1,1,4.787,0l.011.173h-4.81Zm2.395-2.3a2.256,2.256,0,0,0-2.046,2.142h4.1A2.264,2.264,0,0,0,140.3,369.442Z",
    transform: "translate(-137.893 -369.112)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.555,369.184a2.446,2.446,0,0,0-2.224,2.47h4.457A2.453,2.453,0,0,0,142.555,369.184Z",
    transform: "translate(-140.156 -369.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.265,371.741a2.405,2.405,0,1,1,4.789,0l.011.173h-4.812Zm2.388-2.3a2.254,2.254,0,0,0-2.044,2.142h4.1A2.264,2.264,0,0,0,142.653,369.442Z",
    transform: "translate(-140.254 -369.112)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 0.534,
    cy: 0.534,
    r: 0.534,
    transform: "translate(0.425 2.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.534,
    cy: 0.534,
    r: 0.534,
    transform: "translate(5.771 2.845)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.49,368.528a.6.6,0,0,0-.726.348l-.1.246a6.781,6.781,0,0,0,4.193-.132A13.6,13.6,0,0,1,141.49,368.528Z",
    transform: "translate(-134.351 -368.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.435,368.458a.59.59,0,0,1,.724.348l.1.246a6.787,6.787,0,0,1-4.2-.132A13.859,13.859,0,0,0,141.435,368.458Z",
    transform: "translate(-137.679 -368.431)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(0.664 13.555)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "Oswald-Regular, Oswald"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DOT")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a1ad3ae.svg";
export { ForwardRef as ReactComponent };